module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "indent-3"
  }, [_vm._v("Anyone who reads both this book and Richard Ellmann’s magistral biography of Oscar Wilde will at once perceive the debt which the former owes to the latter. I’ve also plundered shamelessly from "), _c('i', [_vm._v("The Queen City")]), _vm._v(" by Lyle W. Dorsett and Michael McCarthy, and from "), _c('i', [_vm._v("Leadville: Colorado’s Magic City")]), _vm._v(" by Edward Blair. I’ve played fast and loose with facts and dates, however (the Leadville Crystal Palace, for example, wasn’t erected until 1896), and I’m totally responsible for all errors, exaggerations, and outright lies.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-06efab8c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/fm02.vue
// module id = 75
// module chunks = 0